import React, { useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Frame from './Frame';
import { officerRegistrationPost, userGet } from '../../api';
import { useHistory } from 'react-router';
import { UserContext } from '../../context/User';
import Loading from '../Loading';

const GovernmentRegistration = () => {
  const history = useHistory();
  const [terms, setTerms] = useState(false);
  const [inputValue, setInputValue] = useState({
    installation: "Fort Bragg"
  });
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(false);

  const registerOfficerRequest = params => {
    officerRegistrationPost(params) 
    .then(response => {
      setLoading(false);
      userGet()
        .then(response => {
          setUser(response.data);
          setLoading(false);
          history.push('/dashboard');
        })
        .catch(error => {
          
        })
    })
    .catch(error => {
      setLoading(false);
    })
  }

  const onChangeHandler = (value, name) => {
    setInputValue({
      ...inputValue,
      [name]: value.value
    })
  }

  const onSubmit = (data, e) => {
    setLoading(true);
    e.preventDefault();
    e.target?.reset();
    for (let prop in data) {
      if (data[prop] === null || data[prop] === undefined || data[prop] === "" || data[prop].length === 0) {
        delete data[prop];
      }
    }

    const params = {...data, ...inputValue};
    registerOfficerRequest(params);
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col lg={{ span: 8, offset: 1 }}>
            <div className="step-header">
              <h2>Contact Information</h2>
              <div className="step-container">
                <p>
                  Step <span>2</span> of 2
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 6, offset: 1 }}>
            <Frame 
              onSubmit={onSubmit} 
              setTerms={setTerms}
              terms={terms}
              inputValue={inputValue}
              onChangeHandler={onChangeHandler}
            />
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>
    </section>
  )
}

export default GovernmentRegistration;